var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "mb-6"
  }, [_c('error-dialog', {
    attrs: {
      "status": _vm.loadStatus
    }
  }), _vm.share ? _c('dialog-scroll-lock', {
    attrs: {
      "content-class": "overflow-visible",
      "width": "300",
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.share = null;
      }
    }
  }, [_c('v-card', {
    staticClass: "relative pa-0"
  }, [_c('v-btn', {
    staticStyle: {
      "top": "-12px",
      "right": "-12px"
    },
    attrs: {
      "absolute": "",
      "x-small": "",
      "fab": "",
      "color": "white"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.share = null;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('social-share-btns', {
    staticClass: "pa-6",
    attrs: {
      "title": _vm.post.title,
      "description": _vm.share.description,
      "url": `https://ellacard.com${_vm.$route.path}${_vm.share.href}`
    }
  })], 1)], 1) : _vm._e(), _c('div', [_c('v-btn', {
    attrs: {
      "exact": "",
      "to": {
        name: 'blog'
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronLeft)
    }
  }), _vm._v(" All blog posts")], 1), _vm.loadStatus.pending ? _c('v-progress-circular', {
    staticClass: "ml-4",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e()], 1), _vm.post ? [_c('div', {
    staticClass: "mt-6 blog-post"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.post.title)
    }
  }), _c('div', {
    staticClass: "grey--text text--darken-1 text-body-1 mb-6"
  }, [_vm._v(" " + _vm._s(_vm.post.author) + " – " + _vm._s(_vm._f("moment")(_vm.post.date + new Date().toISOString().slice(10), 'long-date')) + " ")]), _c('social-share-btns', {
    attrs: {
      "link": "",
      "description": "Ellacard blog post",
      "title": _vm.post.title
    }
  }), _c('div', {
    ref: "content",
    staticClass: "mt-9 mb-16",
    domProps: {
      "innerHTML": _vm._s(_vm.post.content)
    }
  }), _c('figcaption', {
    staticClass: "mb-3"
  }, [_vm._v("This post was first published on Ellacard on " + _vm._s(_vm._f("moment")(_vm.post.date + new Date().toISOString().slice(10), 'long-date')))]), _c('social-share-btns', {
    attrs: {
      "link": "",
      "description": "Ellacard blog post",
      "title": _vm.post.title
    }
  })], 1), _c('v-btn', {
    staticClass: "mt-16",
    attrs: {
      "exact": "",
      "to": {
        name: 'blog'
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronLeft)
    }
  }), _vm._v(" All blog posts ")], 1)] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }